export default function BaseParallax({ children, className, id }) {
  return (
    <section className={`parallax ${className ?? ""}`} id={`${id ?? ""}`}>
      {children}
    </section>
  );
}
